module.exports = __webpack_public_path__ + "static/media/favicon-16x16.d7db993f.png";